"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleAddExistingDriverButtonWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var VehicleAddExistingDriverButtonWidget = /** @class */ (function (_super) {
    __extends(VehicleAddExistingDriverButtonWidget, _super);
    function VehicleAddExistingDriverButtonWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        var vehicle = _this.props.interaction.vehicles[_this.vehicleIndex];
        var allDrivers = [_this.props.interaction.policyHolder].concat(_this.props.interaction.additionalDrivers || []);
        if (vehicle.driverIds && vehicle.driverIds.length !== 0) {
            _this.show = allDrivers.some(function (driver) { return !vehicle.driverIds.includes(driver.personId); });
        }
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    VehicleAddExistingDriverButtonWidget.prototype.render = function () {
        if (this.show) {
            return (React.createElement("button", { type: "button", className: "btn btn-primary btn-next btn-add-existing-driver", onClick: this.handleClick, id: "addDriverToVehicle" + this.vehicleIndex }, this.props.question.label));
        }
        else {
            return "";
        }
    };
    VehicleAddExistingDriverButtonWidget.prototype.handleClick = function () {
        this.props.engine.navigate("vehicle".concat(this.vehicleIndex, "AddExistingDriverPage"), false);
    };
    return VehicleAddExistingDriverButtonWidget;
}(plugin_journey_1.WidgetBase));
exports.VehicleAddExistingDriverButtonWidget = VehicleAddExistingDriverButtonWidget;
//# sourceMappingURL=VehcleAddExistingDriverButtonWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/VehcleAddExistingDriverButtonWidget.js
// module id = 2585
// module chunks = 0